import { ComponentPropsWithoutRef, FC } from 'react';

import Banner from './Banner/Banner';
import Content from './Content/Content';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import { StyledPageRoot } from './Page.styles';
import type { PageVariant } from './Page.types';
import { PageVariantProvider } from './PageContext';

export type { PageFooterVariant } from './Footer/Footer.styles';
export type { PageVariant };

interface PageComposition {
	Content: typeof Content;
	Header: typeof Header;
	Footer: typeof Footer;
	Banner: typeof Banner;
}

export type PageProps = ComponentPropsWithoutRef<'div'> & {
	variant?: PageVariant;
};

export const Page: FC<PageProps> & PageComposition = ({ children, variant = 'default', tw, ...props }) => (
	<PageVariantProvider value={variant}>
		<StyledPageRoot $variant={variant} tw={tw} {...props}>
			{children}
		</StyledPageRoot>
	</PageVariantProvider>
);

Page.Content = Content;
Page.Header = Header;
Page.Footer = Footer;
Page.Banner = Banner;
